import { render, staticRenderFns } from "./RunnitStaticFieldsContainer.vue?vue&type=template&id=2bc221b0"
import script from "./RunnitStaticFieldsContainer.vue?vue&type=script&lang=ts"
export * from "./RunnitStaticFieldsContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports